<ichannel-input
  [value]="inputValue"
  [label]="inputLabel"
  [placeholder]="inputPlaceholder"
  [feedWithEnter]="false"
  (onFocusCallback)="onInputFocus($event)"
  (onKeyupCallback)="onInputKeyup($event)"
  (onBlurCallback)="onInputBlur($event)"
></ichannel-input>

<div class="ul-container">
  <!-- Trying to imitate ichannel-input structure :-/ -->
  <div></div>
  <div>
    <ul [hidden]="!visible">
      <li
        *ngFor="let suggestion of suggestions; let index = index"
        (mousedown)="sendOutput(suggestions[index])"
        [class.selected]="selectedSuggestion === index"
      >
        {{ formatSuggestion(suggestion) }}
      </li>
    </ul>
  </div>
</div>
